import {
  AccountInteractionsDocument,
  InteractionFilter,
  OpportunityInteractionsDocument,
  useDeleteInteractionMutation,
} from 'graphql/bindings/AdminBindings'
import { ActionModal, useSnackbar } from '@forgeglobal/design-framework'
import React from 'react'
import compact from 'lodash/compact'

export const DeleteConversationModal: React.FC<{
  hideModal: () => void
  conversationId: string
  accountId?: string
  opportunityId?: string
  groupFilter: InteractionFilter
}> = props => {
  const { hideModal, conversationId, accountId, opportunityId, groupFilter, children } = props
  const { enqueueSnackbar } = useSnackbar()

  const [deleteInteraction] = useDeleteInteractionMutation({
    variables: {
      id: conversationId,
    },
    refetchQueries: compact([
      //   reload account & issuer opportities
      accountId && {
        query: AccountInteractionsDocument,
        variables: { id: accountId, groupFilter },
      },
      opportunityId && {
        query: OpportunityInteractionsDocument,
        variables: { id: opportunityId, groupFilter },
      },
    ]),
    onCompleted: () => {
      hideModal()
      enqueueSnackbar('Conversation deleted')
    },
  })

  return (
    <ActionModal
      open
      hideModal={hideModal}
      title={'Delete Conversation'}
      cancelAction={hideModal}
      confirmAction={deleteInteraction}
      positiveMessage={'Delete'}
      negativeMessage={'Cancel'}
      header={'Are you sure?'}
      actionMessage={
        'Conversations should only be deleted for invalid data that was accidentally entered. This action is permanent and cannot be undone.'
      }>
      {children}
    </ActionModal>
  )
}
